<template>
  <div>
    <div style="display:flex;justify-content:space-between">
      <div v-if="application.student_details" class="student-details" style="display:flex;justify-content:space-between">
        <div>
          <p><b><v-icon type="mail"></v-icon>&nbsp;e-Mail:</b>
          &emsp;{{application.student_details.personal_details.personal_email}}</p>
          <p><b><v-icon type="mobile"></v-icon>&nbsp;Phone Number:</b>
          &emsp;{{application.student_details.personal_details.phone_number}}</p>
          <p><b><v-icon type="environment-o"></v-icon>&nbsp;Address:</b>
          &emsp;{{application.student_details.personal_details.street_address}}, {{application.student_details.personal_details.city}}, 
          {{application.student_details.personal_details.province}}, {{application.student_details.personal_details.province}},
          {{application.student_details.personal_details.country}} - {{application.student_details.personal_details.zip_code}}</p>
        </div>
        <div style="margin-left:20px;">
          <p><b><v-icon type="book"></v-icon>&nbsp;Highest Education:</b>
          &emsp;{{studyLevels[application.student_details.academic_details.highest_education]}}</p>
          <p><b><v-icon type="file-text"></v-icon>&nbsp;English Language Test:</b>
          &emsp;{{application.student_details.english_language_ability.test}}</p>
          <p><b><v-icon type="solution"></v-icon>&nbsp;Test Score:</b>
          &emsp;
          R {{application.student_details.english_language_ability.reading_score}} |
          W {{application.student_details.english_language_ability.writing_score}} |
          L {{application.student_details.english_language_ability.listening_score}} |
          S {{application.student_details.english_language_ability.speaking_score}} |
          Overall {{application.student_details.english_language_ability.overall_score}}
          </p>
        </div>
      </div>
      <div class="prog-details" style="display:flex;justify-content:space-between">
        <div>
          <p><b><v-icon type="book"></v-icon>&nbsp;Area of study:</b>
          &emsp;{{application.area_of_study}}</p>
          <p><b><v-icon type="check-square-o"></v-icon>&nbsp;Test Score Required:</b>
          &emsp;{{application.ielts}}</p>
          <p><b><v-icon type="clock-circle-o"></v-icon>&nbsp;Duration:</b>
          &emsp;{{application.duration}}</p>
        </div>
        <div style="margin-left:20px;">
          <p><b><v-icon type="environment-o"></v-icon>&nbsp;Province:</b>
          &emsp;{{application.school.province}}</p>
          <p><b><v-icon type="book"></v-icon>&nbsp;Tution Fee:</b>
          &emsp;{{application.tution_fee}}</p>
          <p><b><v-icon type="file"></v-icon>&nbsp;Application Fee:</b>
          &emsp;{{application.application_fee}}</p>
        </div>
      </div>
    </div>
    <div>
      <h4 style="margin:12px 0 6px;font-weight:bold">Uploaded documents</h4>
      <div>
        <div v-if="fetchedUsers.includes(application.userRef.id) && fetchedUserDetails[application.userRef.id].documents_uploaded && fetchedUserDetails[application.userRef.id].documents_uploaded.length">
          <div class="uploaded-documents">
            <div v-for="(doc, index) in fetchedUserDetails[application.userRef.id].documents_uploaded" :key="index">
              <i class="anticon anticon-paper-clip"></i>
              <a :href="doc.url" target="_blank">{{doc.name}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationDetails',
  props: ['application', 'fetchedUsers', 'fetchedUserDetails'],
  data () {
    return {
      studyLevels: {
        G10: 'Grade-10',
        G12: 'Grade-12',
        D1: '1-Year Post-Secondary Certificate',
        D2: '2-Year Undergraduate Diploma',
        D3: '3-Year Undergraduate Advanced Diploma',
        B4: '4-Year Bachelor\'s Degree',
        PG: 'Postgraduate Certificate / Master\'s Degree'
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ApplicationDetails.vue